// 需要清除缓存的路由配置
const CACHE_CLEAR_ROUTES = ["/", "/en", "/zh-hant"]

export default ({ app }) => {
  // 只在客户端执行
  if (process.client) {
    app.router.afterEach((to, from) => {
      try {
        if (CACHE_CLEAR_ROUTES.includes(to.path)) {
          sessionStorage.removeItem("seveneleven_TRACK_IMAGE_MODULE")
        }
      } catch (err) {
        console.error("路由历史记录错误:", err)
      }
    })
  }
}
